<h2 mat-dialog-title>Authorization</h2>
<mat-dialog-content class="holding-authorization-dialog-content">
  <div *ngIf="requestInProgress" class="flex-centered-container fill-height">
    <mat-spinner color="accent" diameter="40"></mat-spinner>
  </div>
  <ng-container *ngIf="!requestInProgress">
    <mat-tab-group class='dense-tabs edis-actions-tabs' (selectedTabChange)='onTabChange($event)' #tabs>

      <!-- Holdings to Authoriztion -->
      <mat-tab label="{{ edisActions.Authorize }}" color="accent">
        <ng-container *ngTemplateOutlet="tabData">
        </ng-container>
      </mat-tab>

      <!-- Holdings to Unauthorization -->
      <mat-tab label="{{ edisActions.Unauthorize }}">
        <ng-container *ngTemplateOutlet="tabData">
        </ng-container>
      </mat-tab>


    </mat-tab-group>
  </ng-container>
</mat-dialog-content>

<div mat-dialog-actions class="flex-space-between edis-dialog-actions">
  <div>
    <div>{{selectedIndex ? authorizedHoldingsSelectedCount : pendingHoldingsSelectedCount}} /
      {{selectedHoldingArr.length}}</div>
    <ng-container *ngIf="selectedHoldingArr.length > 100">
      <div class="max-holdings-warning">{{maxHoldingsWarning}}</div>
    </ng-container>
  </div>
  <div class="flex-centered-container">
    <button mat-raised-button color="accent" (click)="openEDISPopup()">Continue to CDSL</button>
  </div>
</div>

<ng-template #tabData>
  <div class="authorization-holding-content-container">
    <table *ngIf="selectedHoldingArr.length; else emptySelectedHoldingArr" mat-table
      class="dense-table authorization-table" [dataSource]="selectedHoldingArr">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="table-select-header">
          <mat-checkbox #checkbox [checked]="checkAll" [disabled]="!selectedHoldingArr.length"
            (change)=" $event ? selectAll($event.checked,row) : null">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let holding">
          <div>
            <mat-checkbox #checkbox (change)="markCheckedStatus($event.checked,holding)"
              [checked]="selectedIndex ? holding.unauth_checked : holding.auth_checked"
              [disabled]="(selectedIndex ? !holding.unauth_checked : !holding.auth_checked) && checkAll">
            </mat-checkbox>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="symbol">
        <th mat-header-cell *matHeaderCellDef class="table-symbol-header"> Select All </th>
        <td mat-cell *matCellDef="let holding"> {{holding.symbol}} </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef class="table-symbol-header"></th>
        <td mat-cell *matCellDef="let holding">
          <div class="flex-centered-container qty-input-container">
            <input matInput [disabled]="selectedIndex || !holding.auth_checked"
              class="quantity-input quantity-input-enabled"
              [(ngModel)]="selectedIndex ? holding.edis_cancel_qty : holding.selected_auth_quantity" appInputBound
              [minValue]="1" [maxValue]="edisPendingQty(holding)"
              [ngClass]="{'warning-border': (!selectedIndex && holding.warning_border_class),
                    'quantity-input-enabled': (!selectedIndex && holding.auth_checked), 'quantity-input-disabled': (selectedIndex || !holding.auth_checked)}">
            <div *ngIf="!selectedIndex">{{'/' + edisPendingQty(holding)}}</div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</ng-template>

<ng-template #emptySelectedHoldingArr>
  <div class="no-content-message flex-centered-container">Nothing to show here.</div>
</ng-template>